export default __webpack_public_path__ + "static/media/landing-image.6d747335.svg";